<template>
  <div class="application-step" :class="className">
    <template v-if="route === 'refiChooseBorrowerCoSigner'">
      <choose-path :loading="loading" :is-current="isCurrent" @complete="complete" />
    </template>
    <template v-else-if="route === 'refiSchoolInformation'">
      <refi-school-info
        :loading="loading"
        :previous-loading="previousLoading"
        :is-current="isCurrent"
        @previous="previous"
        @complete="complete"
      />
    </template>
    <template v-else-if="route === 'refiBorrowerPersonalInfo'">
      <personal-info-part-one
        :loading="loading"
        :previous-loading="previousLoading"
        :is-current="isCurrent"
        :applicant-type="primaryApplicant"
        :applicant-type-display-name="primaryApplicantDisplayName"
        @previous="previous"
        @complete="complete"
      />
    </template>
    <template v-else-if="route === 'refiBorrowerPersonalInfoContinued'">
      <RefiPersonalInfoPartTwo
        :loading="loading"
        :previous-loading="previousLoading"
        :is-current="isCurrent"
        :applicant-type="primaryApplicant"
        :applicant-type-display-name="primaryApplicantDisplayName"
        @previous="previous"
        @complete="complete"
      />
    </template>
    <template v-else-if="route === 'refiCosignerPersonalInfo'">
      <personal-info-part-one
        :loading="loading"
        :previous-loading="previousLoading"
        :is-current="isCurrent"
        :applicant-type="coApplicant"
        :applicant-type-display-name="coApplicantDisplayName"
        @previous="previous"
        @complete="complete"
      />
    </template>
    <template v-else-if="route === 'refiCosignerPersonalInfoContinued'">
      <refi-personal-info-part-two
        :loading="loading"
        :previous-loading="previousLoading"
        :is-current="isCurrent"
        :applicant-type="coApplicant"
        :applicant-type-display-name="coApplicantDisplayName"
        @previous="previous"
        @complete="complete"
      />
    </template>
    <template v-else-if="route === 'refiShowMyRates'">
      <refi-show-my-rates
        :loading="loading"
        :previous-loading="previousLoading"
        :is-current="isCurrent"
        @previous="previous"
        @complete="complete"
      />
    </template>
    <template v-else-if="route === 'refiShowMyRatesExit'">
      <refi-show-my-rates-exit />
    </template>
    <template v-else-if="route === 'refiCosignerRegistration'">
      <refi-registration
        :loading="loading"
        :previous-loading="previousLoading"
        :is-current="isCurrent"
        :applicant-type="coApplicant"
        :applicant-type-display-name="coApplicantDisplayName"
        @previous="previous"
        @complete="complete"
      />
    </template>
    <template v-else-if="route === 'refiBorrowerAdditionalInfo'">
      <refi-additional-info
        :loading="loading"
        :previous-loading="previousLoading"
        :is-current="isCurrent"
        :applicant-type="primaryApplicant"
        :applicant-type-display-name="primaryApplicantDisplayName"
        :path="path"
        @previous="previous"
        @complete="complete"
      />
    </template>
    <template v-else-if="route === 'refiCosignerAdditionalInfo'">
      <refi-additional-info
        :loading="loading"
        :previous-loading="previousLoading"
        :is-current="isCurrent"
        :applicant-type="coApplicant"
        :applicant-type-display-name="coApplicantDisplayName"
        :path="path"
        @previous="previous"
        @complete="complete"
      />
    </template>
    <template v-else-if="route === 'refiCosignerHardPullConsent'">
      <refi-consent
        :loading="loading"
        :previous-loading="previousLoading"
        :is-current="isCurrent"
        :applicant-type="coApplicant"
        :applicant-type-display-name="coApplicantDisplayName"
        @previous="previous"
        @complete="complete"
      />
    </template>
    <template v-else-if="route === 'refiBorrowerInfo'">
      <is-present-info-part-one
        :loading="loading"
        :previous-loading="previousLoading"
        :is-current="isCurrent"
        :applicant-type="primaryApplicant"
        :applicant-type-display-name="primaryApplicantDisplayName"
        @previous="previous"
        @complete="complete"
      />
    </template>
    <template v-else-if="route === 'refiBorrowerInfoContinued'">
      <refi-is-present-info-part-two
        :loading="loading"
        :previous-loading="previousLoading"
        :is-current="isCurrent"
        :applicant-type="primaryApplicant"
        :applicant-type-display-name="primaryApplicantDisplayName"
        @previous="previous"
        @complete="complete"
      />
    </template>
    <template v-else-if="route === 'refiAddCosigner'">
      <refi-add-cosigner
        :loading="loading"
        :previous-loading="previousLoading"
        :is-current="isCurrent"
        @previous="previous"
        @complete="complete"
      />
    </template>
    <template v-else-if="route === 'refiAddNewCosigner'">
      <refi-add-new-cosigner
        :loading="loading"
        :previous-loading="previousLoading"
        :is-current="isCurrent"
        @previous="previous"
        @complete="complete"
      />
    </template>
    <template v-else-if="route === 'refiCosignerInfo'">
      <is-present-info-part-one
        :loading="loading"
        :previous-loading="previousLoading"
        :is-current="isCurrent"
        :applicant-type="coApplicant"
        :applicant-type-display-name="coApplicantDisplayName"
        @previous="previous"
        @complete="complete"
      />
    </template>
    <template v-else-if="route === 'refiCosignerInfoContinued'">
      <refi-is-present-info-part-two
        :loading="loading"
        :previous-loading="previousLoading"
        :is-current="isCurrent"
        :applicant-type="coApplicant"
        :applicant-type-display-name="coApplicantDisplayName"
        @previous="previous"
        @complete="complete"
      />
    </template>
    <template v-else-if="route === 'refiBorrowerRegistration'">
      <refi-registration
        :loading="loading"
        :previous-loading="previousLoading"
        :is-current="isCurrent"
        :applicant-type="primaryApplicant"
        :applicant-type-display-name="primaryApplicantDisplayName"
        @previous="previous"
        @complete="complete"
      />
    </template>
    <template v-else-if="route === 'refiBorrowerHardPullConsent'">
      <refi-consent
        :loading="loading"
        :previous-loading="previousLoading"
        :is-current="isCurrent"
        :applicant-type="primaryApplicant"
        :applicant-type-display-name="primaryApplicantDisplayName"
        @previous="previous"
        @complete="complete"
      />
    </template>
    <template v-else-if="route === 'refiApproval'">
      <refi-approval :loading="loading" :is-current="isCurrent" @complete="complete" />
    </template>
    <template v-else-if="route === 'refiLoanConfiguration'">
      <refi-loan-configuration
        :loading="loading"
        :previous-loading="previousLoading"
        :is-current="isCurrent"
        @previous="previous"
        @complete="complete"
      />
    </template>
    <template v-else-if="route === 'refiCosignerMaritalStatus'">
      <MaritalStatus
        :loading="loading"
        :is-current="isCurrent"
        :applicant-type="coApplicant"
        :applicant-type-display-name="coApplicantDisplayName"
        @previous="previous"
        @complete="complete"
      />
    </template>
    <template v-else-if="route === 'refiBorrowerMaritalStatus'">
      <MaritalStatus
        :loading="loading"
        :is-current="isCurrent"
        :applicant-type="primaryApplicant"
        :applicant-type-display-name="primaryApplicantDisplayName"
        @previous="previous"
        @complete="complete"
      />
    </template>
    <template v-else-if="route === 'refiBorrowerInvited'">
      <invited-applicant
        :loading="loading"
        :is-current="isCurrent"
        :applicant-type="primaryApplicant"
        :applicant-type-display-name="primaryApplicantDisplayName"
        @previous="previous"
        @complete="complete"
      />
    </template>
    <template v-else-if="route === 'refiCosignerInvited'">
      <invited-applicant
        :loading="loading"
        :is-current="isCurrent"
        :applicant-type="coApplicant"
        :applicant-type-display-name="coApplicantDisplayName"
        @previous="previous"
        @complete="complete"
      />
    </template>
    <template v-else-if="route === 'refiBorrowerInvitedApplicantInfo'">
      <invited-applicant-info-part-one
        :loading="loading"
        :is-current="isCurrent"
        :applicant-type="primaryApplicant"
        :applicant-type-display-name="primaryApplicantDisplayName"
        @previous="previous"
        @complete="complete"
      />
    </template>
    <template v-else-if="route === 'refiBorrowerInvitedApplicantInfoContinued'">
      <refi-invited-applicant-info-part-two
        :loading="loading"
        :is-current="isCurrent"
        :applicant-type="primaryApplicant"
        :applicant-type-display-name="primaryApplicantDisplayName"
        @previous="previous"
        @complete="complete"
      />
    </template>
    <template v-else-if="route === 'refiCosignerInvitedApplicantInfo'">
      <invited-applicant-info-part-one
        :loading="loading"
        :is-current="isCurrent"
        :applicant-type="coApplicant"
        :applicant-type-display-name="coApplicantDisplayName"
        @previous="previous"
        @complete="complete"
      />
    </template>
    <template v-else-if="route === 'refiCosignerInvitedApplicantInfoContinued'">
      <refi-invited-applicant-info-part-two
        :loading="loading"
        :is-current="isCurrent"
        :applicant-type="coApplicant"
        :applicant-type-display-name="coApplicantDisplayName"
        @previous="previous"
        @complete="complete"
      />
    </template>
    <template v-else-if="route === 'refiBorrowerUnderlyingLoansToRefinance'">
      <refi-underlying-loans-to-refinance
        :previous-loading="previousLoading"
        :loading="loading"
        :is-current="isCurrent"
        :applicant-type="primaryApplicant"
        :applicant-type-display-name="primaryApplicantDisplayName"
        @previous="previous"
        @complete="complete"
      />
    </template>
    <template v-else-if="route === 'refiCosignerUnderlyingLoansToRefinance'">
      <refi-underlying-loans-to-refinance
        :loading="loading"
        :is-current="isCurrent"
        :applicant-type="coApplicant"
        :applicant-type-display-name="coApplicantDisplayName"
        @previous="previous"
        @complete="complete"
    /></template>
    <template v-else>
      <slot></slot>
    </template>
    <Feedback @showSupportModal="showSupportModal = true"></Feedback>
    <transition name="modal">
      <support-modal id="supportModal" @close="showSupportModal = false" v-if="showSupportModal" />
    </transition>
  </div>
</template>

<script setup lang="ts">
import { defineAsyncComponent, ref } from "vue";
import Feedback from "@/components/shared/feedback/Feedback.vue";
import SupportModal from "@/components/modals/SupportModal.vue";
import { coApplicantRoutes } from "@/config/constants";
const ChoosePath = defineAsyncComponent(() => import("../application/ChoosePath.vue"));
const RefiSchoolInfo = defineAsyncComponent(() => import("../application/RefiSchoolInfo.vue"));
const PersonalInfoPartOne = defineAsyncComponent(() => import("../application/PersonalInfoPartOne.vue"));
const RefiPersonalInfoPartTwo = defineAsyncComponent(() => import("../application/RefiPersonalInfoPartTwo.vue"));
const IsPresentInfoPartOne = defineAsyncComponent(() => import("../application/IsPresentInfoPartOne.vue"));
const RefiIsPresentInfoPartTwo = defineAsyncComponent(() => import("../application/RefiIsPresentInfoPartTwo.vue"));
const RefiConsent = defineAsyncComponent(() => import("../application/RefiConsent.vue"));
const RefiRegistration = defineAsyncComponent(() => import("../application/RefiRegistration.vue"));
const MaritalStatus = defineAsyncComponent(() => import("../application/MaritalStatus.vue"));
const RefiApproval = defineAsyncComponent(() => import("../application/Approval.vue"));
const RefiAdditionalInfo = defineAsyncComponent(() => import("../application/RefiAdditionalInfo.vue"));
const InvitedApplicant = defineAsyncComponent(() => import("../application/InvitedApplicant.vue"));
const InvitedApplicantInfoPartOne = defineAsyncComponent(
  () => import("../application/InvitedApplicantInfoPartOne.vue"),
);
const RefiInvitedApplicantInfoPartTwo = defineAsyncComponent(
  () => import("../application/RefiInvitedApplicantInfoPartTwo.vue"),
);
const RefiAddCosigner = defineAsyncComponent(() => import("../application/RefiAddCosigner.vue"));
const RefiLoanConfiguration = defineAsyncComponent(() => import("../application/RefiLoanConfiguration.vue"));
const RefiShowMyRates = defineAsyncComponent(() => import("../application/RefiShowMyRates.vue"));
const RefiShowMyRatesExit = defineAsyncComponent(() => import("../application/RefiShowMyRatesExit.vue"));
const RefiUnderlyingLoansToRefinance = defineAsyncComponent(
  () => import("../show-my-rates/RefiUnderlyingLoansToRefinance.vue"),
);
const RefiAddNewCosigner = defineAsyncComponent(() => import("../application/RefiAddNewCosigner.vue"));

const props = defineProps({
  route: { type: String, required: true },
  application: { type: Object, required: true },
  path: { type: String, required: true },
  loading: { type: Boolean, required: true },
  previousLoading: { type: Boolean, required: true },
  isCurrent: { type: Boolean, required: true },
});

const emit = defineEmits(["previous", "complete"]);
const showSupportModal = ref<boolean>(false);
const coApplicant = ref<string>("Co-Applicant");
const primaryApplicant = ref<string>("Primary Applicant");
const primaryApplicantDisplayName = ref<string>("Borrower");
const coApplicantDisplayName = ref<string>("Cosigner");

function className(route: string) {
  return coApplicantRoutes.includes(props.route) === true ? `${route} co-borrower` : `${route}`;
}
// functions that mutate state and trigger updates
function previous(event: any) {
  emit("previous", event);
}
function complete(event: any) {
  emit("complete", event);
}
</script>

<style lang="scss" scoped>
.application-step {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  position: relative;
}

@media (max-width: 992px) {
  .application-step {
    justify-content: flex-start;
  }
}
</style>
